import { db } from 'firebaseConfig';
import {
  collection,
  getDocs,
  query,
  limit,
  orderBy,
  startAfter,
  QueryDocumentSnapshot,
} from 'firebase/firestore';
import { converter } from 'converter';
import { AmazonType } from 'pages/Boys/View/Main/types';
import { Dispatch, SetStateAction } from 'react';
import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  cardInfoErea: {
    padding: '20px',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat( auto-fill, minmax(270px,1fr) )',
    gridGap: '30px',
    justifyContent: 'center',
    backgroundColor: '#F0FFF4',
  },
  card: {
    height: 535,
    width: 270,
    display: 'grid',
    gridGap: '5px',
    gridAutoRows: '380px 150px',
    placeItems: 'center',
    margin: '0 auto',
  },
  cardInfo: {
    height: 150,
    width: 270,
    padding: '0px 10px',
  },
  link: {
    display: 'block',
    margin: 'auto',
  },
  img: {
    display: 'block',
    margin: 'auto',
    width: '100%',
    height:'100%',
    objectFit: 'cover'
  },
});

export const useInit = () => {
  const classes = useStyles();
  const [books, setBooks] = useState<Array<AmazonType>>([]);
  const [lastVisible, setLastVisible] = useState<QueryDocumentSnapshot<AmazonType> | null | undefined>(null);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    (async () => {
      await getAmazonList(lastVisible, setLastVisible, setBooks, setHasMore);
    })();
  }, []);
  console.log('books:', books);

  return { classes, books, setBooks, lastVisible, setLastVisible, setHasMore, hasMore };
};

export async function getAmazonList(
  lastVisible: QueryDocumentSnapshot<AmazonType> | null | undefined,
  setLastVisible: Dispatch<SetStateAction<QueryDocumentSnapshot<AmazonType> | null | undefined>>,
  setData: Dispatch<SetStateAction<AmazonType[]>>,
  setHasMore: Dispatch<SetStateAction<boolean>>
) {
  let collRef = null
  if(lastVisible){
    collRef = query(
      collection(db, 'adult').withConverter(converter<AmazonType>()),
      orderBy('update_time', 'desc'),
      startAfter(lastVisible),
      limit(50)
    );
  }else{
    collRef = query(
      collection(db, 'adult').withConverter(converter<AmazonType>()),
      orderBy('update_time', 'desc'),
      limit(50)
    );
  }

  const snapshot = await getDocs(collRef);

  // Get the last visible document
  lastVisible = snapshot.docs[snapshot.docs.length - 1];
  console.log('lastVisible:', lastVisible);
  setLastVisible(lastVisible);

  const data = snapshot.docs.map((doc) => doc.data());
  setData((prev) => [...prev, ...data]);

  if (lastVisible == null) {
    setHasMore(false);
  }
}
